import script from "./StatsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsSection.vue?vue&type=script&setup=true&lang=js"

import "./StatsSection.vue?vue&type=style&index=0&id=2203d02e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2203d02e"]])

export default __exports__